<template>
  <div class="addAdvertiser">
    <head-panel title="广告主管理" subtitle="ADVERTISERS MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <el-form-item label="广告主名称" prop="adverName">
          <el-input class="input_sm" v-model="form.adverName"></el-input>
        </el-form-item>
        <el-form-item
          label="行业类型"
          prop="industrySecondType"
          :rules="[{ required: true, message: '请选择行业类型', trigger: 'change' }]"
        >
          <ny-select
            :data="accountinfo.form.industryMenu"
            v-model="form.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'form', isEdit: false })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
          ></ny-select>
          <ny-select
            :data="accountinfo.form.industrySecondMenu"
            v-model="form.industrySecondType"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <el-form-item label="网站URL" prop="url">
          <el-tooltip effect="dark" :content="form.url" placement="bottom-start">
            <el-input v-model="form.url" class="input_lg" placeholder="请输入网站URL"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            size="large"
            type="primary"
            @click="submitForm('form')"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
          <el-button size="large" class="is-cancel" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect } from '@/global/components';
import { post, get, put } from '@/manager/http/index'
import { mapGetters } from 'vuex';
import IndustryMixns from '@/global/views/subAccount/industry.js'
export default {
  mixins: [IndustryMixns],
  data () {
    var adverName = (rule, value, callback) => {
      let self = this
      if (value === '') {
        callback(new Error('请输入广告主名称'));
      } else if (value.length > 50) {
        callback(new Error('输入内容不得超过50个字符'));
      } else {
        this.adverNameIsRepeat().then(res => {
          if (res && value !== self.editAdverName) {
            callback(new Error('广告主名称已存在，请重新输入'))
          }
          callback();
        })
      }
    };
    return {
      get: get,
      currentTitle: '新增广告主',
      isAdd: true,
      editAdverName: '',
      committing: false,
      form: {
        adverName: '',
        industrySecondType: '',
        industryType: '',
        url: ''
      },
      rules: {
        adverName: [{ required: true, validator: adverName, trigger: 'blur' }],
        url: [
          { required: false, message: '请输入网站url', trigger: 'blur' },
          { required: false, type: 'url', message: '请输入正确网站url', trigger: 'blur,change' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      advertiser: 'advertiser/advertiser',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.currentTitle = this.$route.name === 'advertiser/add' ? '新增广告主' : '编辑广告主';
      this.isAdd = this.$route.name === 'advertiser/add'
      // this.$store.dispatch('advertiser/getIndustryType')
      if (!this.isAdd) {
        await this.getAdvertiserDetails()
      }
    },
    getAdvertiserDetails () {
      get('/agency/advertiser/' + this.$route.params.id + '/edit').then(res => {
        if (res.code === 1) {
          let params = res.data
          this.form.adverName = params.name
          this.editAdverName = params.name
          this.form.industryType = params.parent_industry + ''
          this.form.industrySecondType = params.industry_id + ''
          this.form.url = params.web_site
        }
      })
    },
    async adverNameIsRepeat () { // 判断计划是否重名
      let flag = false
      if (this.form.adverName !== '') {
        await this.$store.dispatch('advertiser/adverNameIsRepeat', { data: this.form.adverName }).then((data) => {
          if (data && data.code === 1 && data.data.status === 1) {
            flag = true
          } else {
            flag = false
          }
        })
      }
      return flag
    },
    changeSelect ({ select, part }) {
    },
    getParams () {
      let params = {}
      params.name = this.form.adverName
      params.industry_id = this.form.industrySecondType
      params.web_site = this.form.url
      return params
    },
    submitForm (numberValidateForm) {
      this.$refs[numberValidateForm].validate((valid) => {
        if (valid) {
          this.committing = true
          let self = this
          let data = self.getParams()
          if (self.$route.params.id) {
            put('/agency/advertiser/' + self.$route.params.id, data).then(res => {
              if (res.code === 1) {
                self.$message('提交成功')
                self.$router.push({ name: 'advertiser' })
              } else {
                self.$message.error(res.msg)
              }
            })
            return false
          }
          post('/agency/advertiser', data).then(res => {
            if (res.code === 1) {
              self.$message('提交成功')
              self.$router.push({ name: 'advertiser' })
            } else {
              self.$message.error(res.msg)
            }
          })
        }
      });
    },
    cancel () {
      this.$router.push({ name: 'advertiser' });
    }
  },
  components: {
    headPanel,
    NySelect
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.addAdvertiser {
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .tab-radio {
      margin-left: 5%;
      margin-bottom: 22px;
      .radio {
        margin-right: 60px;
      }
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
    }
  }
}
</style>
